module.exports = __webpack_public_path__ + "img/magazine36.3088aa99.jpg";